// Port of api/fuel/app/classes/insights/ratings/year.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

export default Segment.extend({
	name: 'year',
	default_: false,
	insight: ['year'],
	run: function(type, owner, userIndex, detail, filter, vars) {

		var year = (vars && vars.year !== undefined) ? vars.year : false
		var yearType = (filter.year !== undefined) ? filter.year : 'version'
		var games = []

		var collectionIndex = Util.query(
			'SELECT g.game_id AS g, v.game_version_id AS v, g.game_published AS gy, v.game_version_year AS vy, v.game_version_name AS vn,' +
			' AVG(r.rating_value) AS r, COUNT(DISTINCT r.rating_id) AS c' +
			' FROM (rating r JOIN game g ON r.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON r.game_version_id = v.game_version_id' +
			' WHERE r.user_id IN (' + Util.in(userIndex) + ')' +
			' AND g.game_type = 1' +
			' GROUP BY g.game_id, v.game_version_id' +
			' ORDER BY AVG(r.rating_value) DESC, g.game_sortname ASC'
		)

		for (var i = 0; i < collectionIndex.length; i++) {
			var item = collectionIndex[i]
			var collectionYear = (item.vy && yearType === 'version') ? parseInt(item.vy, 10) : parseInt(item.gy, 10)

			if (collectionYear == year) {
				var gameId = parseInt(item.g, 10)
				this._references.games.push(gameId)
				games.push({
					id: gameId,
					subtext: item.v ? item.vn : '',
					rating: parseFloat(item.r),
					count: (userIndex.length > 1) ? parseInt(item.c, 10) : false
				})
			}
		}

		return {
			year: year,
			games: games
		}

	}
})
